type AnyObject = Record<string, unknown>

type CollectFieldPathsOptions = {
  prefix?: string
  acc?: string[]
  ignoreFields?: ReadonlySet<string>
}

// eslint-disable-next-line import/prefer-default-export
export function collectFieldPaths(
  value: unknown,
  options: CollectFieldPathsOptions = {},
): string[] {
  const {
    prefix = '',
    acc = [],
    ignoreFields = new Set<string>(),
  } = options

  if (value == null) {
    if (prefix) acc.push(prefix)
    return acc
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      // Soft-removed rows stay in the form values but are hidden and never submitted,
      // so validating them yields errors on fields the user cannot reach.
      if (item != null && typeof item === 'object' && (item as AnyObject).deleted === true) return

      const path = prefix ? `${prefix}.${index}` : String(index)
      collectFieldPaths(item, { prefix: path, acc, ignoreFields })
    })
    return acc
  }

  if (typeof value === 'object') {
    const obj = value as AnyObject

    Object.entries(obj).forEach(([key, child]) => {
      if (ignoreFields.has(key)) return
      const path = prefix ? `${prefix}.${key}` : key
      collectFieldPaths(child, { prefix: path, acc, ignoreFields })
    })

    return acc
  }

  // primitive leaf
  if (prefix) acc.push(prefix)
  return acc
}
